module.exports = __webpack_public_path__ + "img/lamp-street-solid-full.69873b4d.png";